import { useRef, useState } from "react";
import styles from "../style.module.css";

export default function CustomVideo({ src, poster }) {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const toggleVideo = () => {
        const video = videoRef.current;

        if (!video) return;

        if (video.paused) {
            video.play();
            setIsPlaying(true);
        } else {
            video.pause();
            setIsPlaying(false);
        }
    };

    return (
        <div className={styles.wrapper}>
            <video
                ref={videoRef}
                className={styles.video}
                src={src}
                poster={poster}
                onEnded={() => setIsPlaying(false)}
            />

            <button
                className={styles.playButton}
                onClick={toggleVideo}
            >
                {isPlaying ? (
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="white"
                    >
                        <rect x="6" y="5" width="4" height="14" rx="1" />
                        <rect x="14" y="5" width="4" height="14" rx="1" />
                    </svg>
                ) : (
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="white"
                    >
                        <path d="M8 5v14l11-7z" />
                    </svg>
                )}
            </button>
        </div>
    );
}